module.exports = __webpack_public_path__ + "static/media/thin.svg";